/*
 *
 *  * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *  *    .       .       .       .       .       .       .       .       .       .       .       .
 *  *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *  *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *  *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *  *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *  *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *  *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *  *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *  *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *  *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *  *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *  *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *  *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *  *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *  *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *  *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *  *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *  *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *  *
 *  * Copyright FortyFix(c) 2025.
 *  * Title: version-check.service.ts;
 *  * Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/app/version-check.service.ts;
 *  * Description: ;
 *  * Author: Della Porta Giovanni Battista;
 *  * Created at: 06/11/25, 11:28;
 *  * Updated at: 06/11/25, 11:28;
 *
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private currentVersion = '';
  private storageKey = `${environment.apiUrl.replace(/^https?:\/\//i, "")
    .replace(/^www\./i, "")
    .replace(/\//g, "")}_app_version`;

  constructor(private http: HttpClient) {}

  initVersionCheck(intervalMs: number = 60000) {
    // Controlla ogni minuto (o quello che vuoi)
    interval(intervalMs)
      .pipe(
        switchMap(() => this.http.get<{ version: string }>('assets/version.json?nocache=' + Date.now())
          .pipe(catchError(() => of(null)))
        )
      )
      .subscribe((res) => {
        if (!res) return;
        this.currentVersion = localStorage.getItem(this.storageKey);
        if (!this.currentVersion || this.currentVersion === 'OUTDATED' ) {
          this.currentVersion = res.version;
          localStorage.setItem(this.storageKey, res.version);
          if(!this.currentVersion)
          this.promptUserToReload();
          return;
        }
        if (res.version !== this.currentVersion) {
          this.promptUserToReload();
        }
      });
  }

  private promptUserToReload() {
    console.log('New version detected');
    localStorage.setItem(this.storageKey, 'OUTDATED');

    const cleanUrl = window.location.origin + window.location.pathname;
    const reloadUrl = cleanUrl + '?_reload=' + Date.now();

    // Fase 1: forzo reload bypassando cache
    window.location.replace(reloadUrl);
  }
}
